import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { ONLINE_STORE_SET_PRODUCT_EXPORT_ID } from 'actions/onlineStore/constants';

const exportId = createReducer(null, {
  [ONLINE_STORE_SET_PRODUCT_EXPORT_ID]: (draft, { payload }) =>
    payload.exportId,
});

export default combineReducers({
  exportId,
});
